import React from 'react';

const DeclaracoesAduaneirasContext = React.createContext();

export default DeclaracoesAduaneirasContext;
